import { i18n } from "translate/i18n";

export const IS_PT_LANGUAGE = /^pt/.test(i18n.language);
export const IS_EN_LANGUAGE = /^en/.test(i18n.language);
export const IS_ID_LANGUAGE = /^id/.test(i18n.language);
export const IS_PL_LANGUAGE = /^pl/.test(i18n.language);
